<div [formGroup]="form">
    <app-ativacao-section-card
        [control]="overrideControl"
        titulo="Data de competência"
        [exibirTituloNoAlerta]="false"
        descricaoAtivo="Data de competência personalizada. A NFS-e usará a data informada abaixo no lugar da data de emissão."
        descricaoInativo="Data de competência padrão. A NFS-e usará a data de emissão como competência."
        emptyStateIcone="event_available"
        emptyStateTitulo="Data de competência padrão"
        emptyStateDescricao="Por padrão, a data de competência da NFS-e é a data de emissão. Ative acima para informar uma data diferente."
        (ativacaoChange)="onOverrideChange($event)">
    </app-ativacao-section-card>

    @if (overrideControl.value) {
    <div class="section-container">
    <div class="section-title">
        <mat-icon class="material-symbols-outlined">event</mat-icon>
        <span>ISSQN - Data de competência</span>
    </div>

    <div class="row g-3">
        <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Data de competência</mat-label>
                <input matInput [matDatepicker]="pickerCompetencia"
                    formControlName="dataCompetenciaIssqn"
                    placeholder="DD/MM/AAAA"
                    inputmode="numeric"
                    maxlength="10"
                    (input)="onDateInput($event)"
                    (keydown)="onDateKeydown($event)"
                    (blur)="onDateBlur($event)">
                <mat-datepicker-toggle matIconSuffix [for]="pickerCompetencia"></mat-datepicker-toggle>
                <mat-datepicker #pickerCompetencia></mat-datepicker>
            </mat-form-field>
        </div>
    </div>
    </div>
    }
</div>
